import React, { useContext, useEffect, useRef, useState } from "react";
import useDebounce from "../useDebounce";
import "./SingleSelectDropdownInfinite.css"; // optional styling
import { UserContext } from "context";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

const SingleSelectDropdownInfinite = ({
    singleDropClass,
    label = "",
    placeholder = "",
    fetchData,
    onChange,
    selectedItem = null,
    pageSize = 10,
    disabled = false,
    error = false,
    errorMessage = "",
    isAddButton = false,
    addButtonAction = (e) => { },
    resetTrigger = null,
    consignorId = "",
    consigneeId = "",
    unitId = "",
    loadOnOpen = false,
    padding = "10px",// NEW PROP: agar true hai to dropdown open hone par hi API call hogi
    vehicleStatus = true
}) => {
    const {
        masterData,
    } = useContext(UserContext);
    const [search, setSearch] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [items, setItems] = useState([]);
    const [displayedItems, setDisplayedItems] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [selected, setSelected] = useState(selectedItem);
    const [initialLoadDone, setInitialLoadDone] = useState(false); // NEW STATE
    const debouncedSearch = useDebounce(search, 500);
    const containerRef = useRef(null);

    useEffect(() => {
        setSelected(selectedItem);
    }, [selectedItem]);

    // Debounced search effect
    useEffect(() => {
        if (loadOnOpen) {
            // Agar loadOnOpen true hai to sirf jab dropdown open ho tab search par load karo
            if (dropdownOpen && initialLoadDone) {
                loadItems(true, debouncedSearch, 1);
            }
        } else {
            // Agar loadOnOpen false hai to purane behavior ke according load karo
            loadItems(true, debouncedSearch, 1);
        }
    }, [debouncedSearch]);

    // Reset trigger effect
    useEffect(() => {
        if (resetTrigger || consignorId || consigneeId || unitId) {
            setItems([]);
            setDisplayedItems([]);
            setPage(1);
            setInitialLoadDone(false);

            // Agar loadOnOpen false hai ya dropdown already open hai to load karo
            if (!loadOnOpen || dropdownOpen) {
                loadItems(true, search, 1);
            }
        }
    }, [resetTrigger, consignorId, consigneeId, unitId]);

    // Dropdown open/close effect - Sirf ek baar call hogi
    useEffect(() => {
        if (dropdownOpen && loadOnOpen && !initialLoadDone) {
            // Jab dropdown pehli baar open ho aur loadOnOpen true ho
            loadItems(true, search, 1);
            setInitialLoadDone(true);
        }
    }, [dropdownOpen]);

    const loadItems = async (reset = false, query = search, nextPage = 1) => {
        if (!reset) setIsLoadingMore(true);
        const response = await fetchData(query, nextPage, pageSize);
        const newItems = response?.items || [];
        const total = response?.total || 0;

        const merged = reset ? newItems : [...displayedItems, ...newItems];
        setItems(reset ? newItems : [...items, ...newItems]);
        setDisplayedItems(merged);
        setPage(nextPage);
        setHasMore(merged.length < total);
        setIsLoadingMore(false);
    };

    const loadMore = () => {
        if (hasMore && !isLoadingMore) {
            const nextPage = page + 1;
            loadItems(false, search, nextPage);
        }
    };

    const handleScroll = () => {
        const el = containerRef.current?.querySelector(".dropdown-list");
        if (el && el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
            loadMore();
        }
    };

    const handleSelect = (item) => {
        if (disabled) return;
        setSelected(item);
        setDropdownOpen(false);
        onChange && onChange(item);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div ref={containerRef} className={singleDropClass} style={{ position: "relative", width: "100%" }}>
            <div onClick={() => !disabled && setDropdownOpen(!dropdownOpen)}
                style={{
                    border: error ? "1px solid red" : "1px solid #dee2e6",
                    padding: padding,
                    borderRadius: 4,
                    cursor: disabled ? "not-allowed" : "pointer",
                    backgroundColor: disabled ? "#fcfcfc" : "#fff",
                }}>
                <label
                    style={{
                        position: "absolute",
                        top: dropdownOpen || selected ? -0 : error ? "36%" : "50%",
                        left: 6,
                        fontSize: dropdownOpen || selected ? 12 : 14,
                        color: "#666",
                        background: "#fff",
                        padding: "0 4px",
                        transform: "translateY(-50%)",
                        transition: "all 0.2s ease",
                        pointerEvents: "none",
                    }}
                >
                    {label}
                </label>
                <span style={{
                    color: selected ? "#000" : "",
                    fontSize: 14
                }}>
                    {selected?.vehicle_ownership
                        ? `${selected?.name} | ${masterData?.vehicle_ownership[selected?.vehicle_ownership]}`
                        : (selected?.name || label || placeholder)}
                </span>
                <span style={{ float: "right" }}>{dropdownOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
            </div>

            {dropdownOpen && !disabled && (
                <div
                    className="dropdown-list"
                    style={{
                        position: "absolute",
                        top: "100%",
                        width: "100%",
                        maxHeight: 250,
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: 4,
                        zIndex: 1000,
                        marginTop: 4,
                        display: "flex",
                        flexDirection: "column",
                    }}
                    onScroll={handleScroll}
                >
                    <div className="__searchIn_multiBx">
                        <input
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search..."
                            style={{
                                width: "100%",
                                padding: "8px",
                                boxSizing: "border-box",
                                borderBottom: "1px solid #ccc",
                            }}
                            autoFocus
                        />
                    </div>
                    <div className="__otr_checkBx_fl">
                        {displayedItems.map((item) => {
                            return (
                                <div
                                    key={item._id}
                                    onClick={() => handleSelect(item)}
                                    style={{
                                        padding: "8px 12px",
                                        backgroundColor: selected?._id === item._id ? "#1450ec" : "#fff",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 10,
                                        borderBottom: "1px solid #e8eaed",
                                        color: selected?._id === item._id ? "#ffff" : ""
                                    }}
                                >
                                    {(!item.ownershipStatus && !item.trip_status) && item.name}

                                    {item.ownershipStatus && (
                                        <>
                                            <React.Fragment>
                                                <div className="anvLrc ">
                                                    <div className="_vhlNumber" style={{color:selected?._id === item._id?"#ffff":""}}>{item.name}</div>
                                                    <div className="_vhlOwnType" style={{color:selected?._id === item._id?"#ffff":""}}>
                                                        <span
                                                            className={
                                                                item.ownershipStatus == 1
                                                                    ? "_trkMark _lrDelivered_status"
                                                                    : item.ownershipStatus == 2
                                                                        ? "_trkMark _lrPartyPoint_status"
                                                                        : "_trkMark _lrInTransit_status"
                                                            }
                                                        >
                                                            {
                                                                masterData?.vehicle_ownership[
                                                                item.ownershipStatus
                                                                ]
                                                            }
                                                        </span>
                                                        {item.lorry_type_id?.lorry_type && item.vehicle_type_id_1?.name
                                                            ? ` | ${item.lorry_type_id.lorry_type} ${item.vehicle_type_id_1.name}`
                                                            : ''}
                                                    </div>
                                                </div>
                                                {vehicleStatus && <div className="_vhlStatus">
                                                    <span className="available_status"></span>

                                                    {`${masterData?.vehicle_status[
                                                        item?.vehicle_status
                                                    ]
                                                        }`}
                                                </div>}
                                            </React.Fragment>
                                        </>
                                    )}

                                    {item.trip_status && (
                                        <>
                                            <React.Fragment>
                                                <div className="anvLrc ">
                                                    <div className="_vhlNumber">{item.name}</div>
                                                    <div className="_vhlOwnType">
                                                        {item.route_name && `  ${item.route_name}`}
                                                    </div>
                                                </div>
                                                <div className="_vhlStatus">
                                                    <span
                                                        className={
                                                            masterData?.trip_status[item?.trip_status] === "Pending"
                                                                ? "_lrPending_status"
                                                                : masterData?.trip_status[item?.trip_status] === "In Transit"
                                                                    ? "_lrInTransit_status"
                                                                    : masterData?.trip_status[item?.trip_status] === "At Party Point"
                                                                        ? "_lrPartyPoint_status"
                                                                        : masterData?.trip_status[item?.trip_status] === "Delivered"
                                                                            ? "_lrDelivered_status"
                                                                            : masterData?.trip_status[item?.trip_status] === "Bill Raised"
                                                                                ? "_lrDelivered_status"
                                                                                : masterData?.trip_status[item?.trip_status] === "Cancelled"
                                                                                    ? "_lrCanceled_status"
                                                                                    : ""
                                                        }
                                                    >
                                                        {masterData?.trip_status[item.trip_status]}
                                                    </span>
                                                </div>
                                            </React.Fragment>
                                        </>
                                    )}
                                </div>
                            )
                        })}
                    </div>

                    {isLoadingMore && (
                        <div style={{ padding: 8, textAlign: "center", fontSize: 12 }}>
                            Loading...
                        </div>
                    )}

                    {displayedItems.length === 0 && !isLoadingMore && (
                        <div style={{ padding: 8, textAlign: "center", fontSize: 12 }}>
                            No Data
                        </div>
                    )}
                    {isAddButton && <div
                        onClick={() => {
                            if (addButtonAction) {
                                addButtonAction();
                                setDropdownOpen(false)
                            }
                        }}
                        style={{
                            borderTop: "1px solid #ccc",
                            background: "#fff",
                            padding: 5,
                            position: "sticky",
                            bottom: 0,
                            zIndex: 2,
                        }}

                    >
                        <button
                            className="_addNew_cdmBtn"

                            onClick={() => {
                                if (addButtonAction) {
                                    addButtonAction();
                                    setDropdownOpen(false)
                                }
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 18 18"
                                fill="none"
                            >
                                <path
                                    d="M8.61539 0C6.33902 0.0276205 4.16368 0.944178 2.55393 2.55393C0.944178 4.16368 0.0276205 6.33902 0 8.61539C0.0276205 10.8917 0.944178 13.0671 2.55393 14.6768C4.16368 16.2866 6.33902 17.2031 8.61539 17.2308C10.8917 17.2031 13.0671 16.2866 14.6768 14.6768C16.2866 13.0671 17.2031 10.8917 17.2308 8.61539C17.2031 6.33902 16.2866 4.16368 14.6768 2.55393C13.0671 0.944178 10.8917 0.0276205 8.61539 0ZM13.5385 9.23077H9.23077V13.5385H8V9.23077H3.69231V8H8V3.69231H9.23077V8H13.5385V9.23077Z"
                                    fill="#1956F6"
                                />
                            </svg>
                            Add New
                        </button>
                    </div>}
                </div>
            )}

            {error && errorMessage && (
                <div style={{ color: "red", fontSize: 12, marginTop: 4, fontWeight: 500 }}>
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

export default SingleSelectDropdownInfinite;